export const heroSlides = [
  {
    id: 'slide-001',
    title: '善良的女秘书',
    subtitle: '年度暖心职场剧 · 一个关于善意与成长的故事',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20warm%20deep%20red%20modern%20corporate%20office%20at%20golden%20hour%2C%20a%20young%20professional%20woman%20standing%20by%20floor-to-ceiling%20windows%2C%20soft%20light%20rays%2C%20minimal%20elegant%20composition%2C%20high%20detail%2C%20dramatic%20contrast%20for%20text%20overlay&width=1600&height=900&seq=hero-slide-001&orientation=landscape',
    linkType: 'drama',
    linkId: 'tv-001',
    badge: '热播推荐',
  },
  {
    id: 'slide-002',
    title: '暗夜追凶',
    subtitle: '悬疑刑侦大剧 · 十年悬案，真相将至',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20rainy%20neon%20city%20street%20at%20night%20with%20deep%20red%20reflections%20on%20wet%20asphalt%2C%20moody%20atmospheric%20lighting%2C%20minimal%20dramatic%20composition%2C%20high%20detail%2C%20strong%20contrast%20for%20text%20overlay&width=1600&height=900&seq=hero-slide-002&orientation=landscape',
    linkType: 'drama',
    linkId: 'tv-007',
    badge: '高分口碑',
  },
  {
    id: 'slide-003',
    title: '山海之约',
    subtitle: '都市爱情新作 · 十年之约，跨越山海',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20coastal%20mountain%20landscape%20at%20dusk%20with%20warm%20deep%20red%20sunset%20glow%20and%20soft%20mist%2C%20two%20distant%20figures%2C%20minimal%20atmospheric%20composition%2C%20high%20detail%2C%20dramatic%20contrast%20for%20text%20overlay&width=1600&height=900&seq=hero-slide-003&orientation=landscape',
    linkType: 'drama',
    linkId: 'tv-006',
    badge: '独家上线',
  },
  {
    id: 'slide-004',
    title: '国产悬疑剧再出爆款',
    subtitle: '行业动态 · 观众为何重新爱上好故事',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20cinema%20screen%20glowing%20in%20a%20dark%20warm%20red%20theater%2C%20silhouettes%20of%20audience%2C%20minimal%20dramatic%20composition%2C%20high%20detail%2C%20strong%20contrast%20for%20text%20overlay&width=1600&height=900&seq=hero-slide-004&orientation=landscape',
    linkType: 'news',
    linkId: 'news-002',
    badge: '影视资讯',
  },
  {
    id: 'slide-005',
    title: '深巷暖阳',
    subtitle: '年代家庭巨制 · 一巷烟火，半生温情',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20an%20old%20Chinese%20alley%20bathed%20in%20warm%20golden%20afternoon%20light%2C%20red%20lanterns%20and%20textured%20walls%2C%20nostalgic%20atmosphere%2C%20minimal%20composition%2C%20high%20detail%2C%20dramatic%20contrast%20for%20text%20overlay&width=1600&height=900&seq=hero-slide-005&orientation=landscape',
    linkType: 'drama',
    linkId: 'tv-003',
    badge: '口碑佳作',
  },
];